import { Component, OnInit } from '@angular/core';
import { SelectItem} from 'primeng';
import { ScreenName, UserActionDescription } from 'src/app/enum/user/userActionDescription';
import { UserAction } from 'src/app/enum/user/userActions';
import { AccessUserInfo, UserDetail, UserLocationFacility } from 'src/app/models';
import { FacilityService, UserService } from 'src/app/services';
import { LoaderService } from 'src/app/services/loader.service';
@Component({
  selector: 'bart-shipping-manifest',
  templateUrl: './shipping-manifest.component.html',
  styleUrls: ['./shipping-manifest.component.scss']
})
export class ShippingManifestComponent implements OnInit {
  facilityList: SelectItem[] = [];
  public userInfo: UserDetail;
  userLocationFacilities: UserLocationFacility[] = [];
  selectedFacilityMasterId?: number = null;
  activeTab: string ="pendings";
  constructor(
    private _facilityService: FacilityService,
    private _loaderService: LoaderService,
    private _userService:UserService
  ) { }

  ngOnInit() {
    this.userInfo = AccessUserInfo.getUserInfo();
    this.selectedFacilityMasterId= AccessUserInfo.getSelectedFacilityMasterId()
    this.GetUserLocations()
  }
  private GetUserLocations() {
    this._loaderService.show();
    this.facilityList = [];
    let getLocationParam =
    {
      "GETUSERLOCATIONS":
      {
        LOCATION_ID_LIST: null,
        USERNAME: this.userInfo.userName,
      },
      "GETUSERLOCATIONS2":
      {
        USERNAME: this.userInfo.userName,
      }
    }
    if (getLocationParam != null) {
      this._facilityService.getUserLocations(JSON.stringify(getLocationParam))
        .subscribe((resp: any) => {
          if (resp.facilities) {
            this.userLocationFacilities=resp.facilities
            this.facilityList = this.userLocationFacilities.filter(x=>x.LocationModality && x.LocationModality.length>0).map(data => ({
              label: data.FacilityDisplayName,
              value: data.FacilityMasterID,
            }));
            if (this.facilityList && this.facilityList.length && this.selectedFacilityMasterId==null) {
              this.selectedFacilityMasterId = this.facilityList[0].value;
            }
            this._loaderService.hide();
          }
          else {
            this._loaderService.hide();
          }

        },
          (error) => {
            this._loaderService.hide();
            this.facilityList = [];
          });
    }
  }
  public handleTabChanged(event)
  { 
      if (event.index== 0)
      {
        this.activeTab = "pendings";
         
      }
      if (event.index== 1)
      {
        this.activeTab = "historical";
    
      }

      let userActionDesc = event.index== 0?UserActionDescription.SHIPPING_MANIFEST_PENDING_TAB_CLICKED:UserActionDescription.SHIPPING_MANIFEST_HISTORICAL_TAB_CLICKED
      //#region User Action Audit
      this._userService.logUserAction({
        userName: this.userInfo.userName,
        userAction: UserAction.TAB_CLICKED,
        screenName: ScreenName.SHIPPING_MANIFEST,
        screenPath: location.pathname,
        key: "FacilityMasterId",
        value: this.selectedFacilityMasterId,
        eventDescription:userActionDesc
      });


  }
  facilityChanged()
  {
    AccessUserInfo.setSelectedFacilityMasterId(this.selectedFacilityMasterId.toString())
    //#region User Action Audit
    this._userService.logUserAction({
      userName: this.userInfo.userName,
      userAction: UserAction.FILTER,
      screenName: ScreenName.SHIPPING_MANIFEST,
      screenPath: location.pathname,
      key: "FacilityMasterID",
      value: this.selectedFacilityMasterId,
      eventDescription:UserActionDescription.SHIPPING_MANIFEST_FACILITY_CHANGED
    });
    //#endregion
  }
}
